/**
 * Viewing scope for facilitators. Admins are not assigned to a college;
 * this is session-local only (not stored on the user profile).
 */
const KEY = 'u80_admin_session'

export function getAdminSession() {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return { collegeName: '', collegeId: '' }
    const parsed = JSON.parse(raw)
    return {
      collegeName: parsed.collegeName || '',
      collegeId: parsed.collegeId || '',
    }
  } catch {
    return { collegeName: '', collegeId: '' }
  }
}

export function setAdminSession({ collegeName, collegeId } = {}) {
  const next = {
    collegeName: collegeName || '',
    collegeId: collegeId || '',
  }
  try {
    sessionStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    /* ignore quota / private mode */
  }
  try {
    window.dispatchEvent(new CustomEvent('u80-session-changed'))
  } catch {
    /* ignore */
  }
  return next
}
